import { useQuery } from "@apollo/client/react";

import {
  GetRecordUpdateDataImportProjectTargetsDocument,
  type GetRecordUpdateDataImportProjectTargetsQuery,
  type GetRecordUpdateDataImportProjectTargetsQueryVariables,
} from "~/features/dataImportProjects/gqls";
import { useTenant } from "~/features/tenant/context";

/**
 * Lists the active target batches for a DIP. A null lifecycle means the DIP is
 * not a record-update DIP, so callers can safely use it as the UI discriminator.
 */
export const useRecordUpdateTargets = (dataImportProjectId: string | undefined) => {
  const { tenantId } = useTenant();
  const { data, loading, error, refetch } = useQuery<
    GetRecordUpdateDataImportProjectTargetsQuery,
    GetRecordUpdateDataImportProjectTargetsQueryVariables
  >(GetRecordUpdateDataImportProjectTargetsDocument, {
    variables: { input: { tenantId: tenantId ?? "", dataImportProjectId: dataImportProjectId ?? "" } },
    skip: !tenantId || !dataImportProjectId,
    fetchPolicy: "network-only",
  });

  return {
    lifecycle: data?.cnutGetRecordUpdateDataImportProjectTargets.lifecycle ?? null,
    batches: data?.cnutGetRecordUpdateDataImportProjectTargets.batches ?? [],
    loading,
    error,
    refetch,
  };
};
